export default {
  overview: hosts => ({
    id: 'SECONDARY_ANALYTICS_OVERVIEW',
    host: hosts.perform,
    href: '/analytics/overview',
    otherHrefs: [],
    name: I18n.t('Overview'),
  }),
  learners: hosts =>  ({
    id: 'SECONDARY_ANALYTICS_TRANSCRIPT',
    host: hosts.perform,
    href: '/analytics/transcript',
    otherHrefs: [],
    name: I18n.t('Transcript'),
  }),
  journeys: hosts =>  ({
    id: 'SECONDARY_ANALYTICS_JOURNEYS',
    host: hosts.perform,
    href: '/analytics/journeys',
    otherHrefs: [],
    name: I18n.t('Journeys'),
  }),
  usageMetrics: hosts => ({
    id: 'SECONDARY_ANALYTICS_USAGE_METRICS',
    host: hosts.perform,
    href: '/analytics/usage-metrics',
    otherHrefs: [],
    name: I18n.t('Usage Metrics'),
  }),
  goals: hosts => ({
    id: 'SECONDARY_ANALYTICS_GOALS',
    host: hosts.perform,
    href: '/analytics/goals',
    otherHrefs: [],
    name: I18n.t('Goals'),
    okrName: I18n.t('Objectives'),
  }),
  leaderboard: hosts => ({
    id: 'SECONDARY_ANALYTICS_LEADERBOARD',
    host: hosts.perform,
    href: '/analytics/leaderboard',
    otherHrefs: [],
    name: I18n.t('Leaderboard'),
  }),
};



// WEBPACK FOOTER //
// ./packages/bridge-global-nav/src/utils/buildAtlasLinks/primaryLinks/analytics.js